export enum ReviewAuthorCountry {
  'KR' = 'KR',
  'JP' = 'JP',
  'TH' = 'TH',
  'ZZ' = 'ZZ',
}

export enum ReviewHospitalCountry {
  'KR' = 'KR',
  'JP' = 'JP',
  'ZZ' = 'ZZ',
}
